import { isArray, isObject, isUndefined } from 'lodash-es';
import type { PlatformAuthenticationConfig } from './platform-authentication-config';

type OpenIdConfiguration = {
  scopes_supported: string[];
};

export async function hasAccessToResource(config: PlatformAuthenticationConfig, realm: string) {
  if (config.clientId === 'portal') {
    return true;
  }

  if (isUndefined(config.resourceName)) {
    throw new Error('A resource name must be configured for all clients with the exception of the portal client.');
  }

  try {
    const url = config.getInstanceUrl();
    const response = await fetch(`${url}realms/oneplatform/.well-known/openid-configuration`);
    const openIdConfiguration: OpenIdConfiguration = await response.json();

    if (!isObject(openIdConfiguration) || !isArray(openIdConfiguration.scopes_supported)) {
      throw new Error('Cannot read supported scopes from OpenID configuration.');
    }

    return openIdConfiguration.scopes_supported.includes(config.resourceName);
  } catch (error) {
    return false;
  }
}
